import DashboardViewer from "./DashboardViewer";

export default DashboardViewer;
